<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <o-t-p-keyboard
      :title="$t(title)"
      @submit="checkPinCode"
    />
  </div>
</template>

<script>
import { getPinCode } from '@/model/dataLayer/api/SaaS/user'
import OTPKeyboard from '@/views/widget/PINInput/OTPKeyboard.vue'

export default {
  name: 'CheckPinCodeFragment',
  components: {
    OTPKeyboard
  },

  data () {
    return {
      userCurrentPinCode: '',
      title: 'PersonalSettingsOldPin'
    }
  },
  async mounted () {
    this.userCurrentPinCode = (await getPinCode()).pinCode
  },
  methods: {
    checkPinCode (code) {
      if (code === this.userCurrentPinCode) {
        this.$emit('passed')
      } else {
        this.title = 'PersonalSettingsCurrentPinReEnter'
      }
    }
  }

}
</script>

<style scoped>

</style>
